import { Box, Stack } from '@mui/material';
import { useState } from 'react';

import { TourTravel } from '@/domain/project-tour-ontour/entities/project-tour-ontour-travel.entity';
import ArrowDirectBottom from '@/ui/assets/arrow-direct-bottom.svg';
import ArrowDirectTop from '@/ui/assets/arrow-direct-top.svg';

import { FavoriteTravelGroupOption } from '../../utils/tour-travel-favorite-group';
import { ModalTourTravelGroupForm } from '../tour-travel-view/ModalTourTravelGroupForm';
import { TourTravelItem } from './TourTravelItem';

export function TourTraveListDirect({
  tourTravels,
  onClickDelete,
  onClickAdd,
  favoriteIds,
  onToggleFavorite,
  favoriteTravels,
  onCopyTravel,
  isWindowFavorite,
  onToggleWindowFavorite,
  favoriteGroups,
  onCopyGroup,
}: {
  tourTravels: TourTravel[];
  onClickDelete: (tourTravelId: number) => void;
  onClickAdd: () => void;
  favoriteIds: Set<number>;
  onToggleFavorite: (id: number) => void;
  favoriteTravels: TourTravel[];
  onCopyTravel: (sourceTourTravel: TourTravel) => void;
  isWindowFavorite: boolean;
  onToggleWindowFavorite: () => void;
  favoriteGroups: FavoriteTravelGroupOption[];
  onCopyGroup: (travels: TourTravel[]) => void;
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeTravelIndex, setActiveTravelIndex] = useState(0);

  const onClickOpen = (index: number) => {
    setActiveTravelIndex(index);
    setModalOpen(true);
  };

  if (tourTravels.length === 0) {
    return null;
  }

  return (
    <>
      <ModalTourTravelGroupForm
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        tourTravels={tourTravels}
        initialIndex={activeTravelIndex}
        onClickAdd={onClickAdd}
        onDelete={onClickDelete}
        favoriteIds={favoriteIds}
        onToggleFavorite={onToggleFavorite}
        favoriteTravels={favoriteTravels}
        onCopyTravel={onCopyTravel}
        isWindowFavorite={isWindowFavorite}
        onToggleWindowFavorite={onToggleWindowFavorite}
        favoriteGroups={favoriteGroups}
        onCopyGroup={onCopyGroup}
      />
      <Stack
        sx={{
          alignItems: 'center',
          mt: -0.5, // arrow-direct-top top : above previous event
          mb: -0.75, // arrow-direct-bottom bottom : touch the next event
        }}
      >
        <Box
          sx={{
            mb: -0.75, // arrow-direct-bottom bottom : touch the travel
          }}
        >
          <img src={ArrowDirectTop} />
        </Box>
        {tourTravels.map((tourTravel, index) => (
          <Stack key={tourTravel.id}>
            <TourTravelItem
              tourTravel={tourTravel}
              onClickDelete={onClickDelete}
              onClickOpen={() => onClickOpen(index)}
              isFavorite={favoriteIds.has(tourTravel.id)}
            />
          </Stack>
        ))}
        <Box
          sx={{
            mt: -0.5, // arrow-direct-bottom top : above the travel
          }}
        >
          <img src={ArrowDirectBottom} />
        </Box>
      </Stack>
    </>
  );
}
